<template>
	<CDropdown
		in-nav
		placement="bottom-end"
		add-menu-classes="pt-0"
		class="c-header-nav-items"
	>
		<template #toggler>
			<CHeaderNavLink class="container-profile">
				<div class="container-profile-info">
					<div class="container-profile-info-name">
						{{ meInfo.name }}
					</div>
					<div class="container-profile-info-role">
						{{ meInfo.role | capitalize }}
					</div>
				</div>
				<div class="c-avatar">
					<CIcon name="cil-user" />
				</div>
			</CHeaderNavLink>
		</template>
		<CDropdownHeader
			tag="div"
			color="light"
			class="text-center"
		>
			<strong>
				{{ $t('message.dropdown_section_account') }}
			</strong>
		</CDropdownHeader>
		<CDropdownItem :to="{name: ROUTER_NAME.PROFILE_EDIT}">
			<CIcon name="cil-user" class="dropdown-item-icon" />
			<span>
				{{ $t('message.edit_profile') }}
			</span>
		</CDropdownItem>
		<CDropdownItem @click="onClickLogout">
			<CIcon name="cil-lock-locked" class="dropdown-item-icon" />
			<span>
				{{ $t('message.logout') }}
			</span>
		</CDropdownItem>
	</CDropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'TheHeaderDropdownAccnt',

	data() {
		return {
			ROUTER_NAME,
		};
	},

	computed: {
		...mapState('me', {
			meInfo: 'data',
		}),
	},

	methods: {
		...mapActions('auth', {
			logout: 'logout',
		}),
		...mapActions('me', {
			clearMe: 'clear',
		}),
		async onClickLogout() {
			await this.logout();
			await this.clearMe();

			// redirect to logout pages
			this.$router.push({ name: ROUTER_NAME.LOGIN });
		},
	},
};
</script>

<style lang="scss" scoped>
.dropdown-item-icon {
	position: relative;
	top: rem(-2);
	margin-right: rem(10);
}

.container-profile {
	margin-right: rem(20);

	.c-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
		width: rem(32);
		height: rem(32);
		border: 1px solid $color-gray-400;
	}

	&-info {
		@include typo-helper-text;

		display: flex;
		flex-direction: column;
		margin-right: rem(10);
		pointer-events: none;

		&-name {
			font-weight: $font-weight-bold;
		}

		&-role {
			font-size: rem(11);
		}
	}
}
</style>
